// src/pages/Home/components/sections/AchievementsSection.jsx
import React from "react";
import ach1 from "../../../assets/images/v/A1.jpeg";
import ach2 from "../../../assets/images/v/A2.jpg";
import ach3 from "../../../assets/images/v/A3.jpg";
import ach4 from "../../../assets/images/v/A4.png";

export default function AchievementsSection({ lang }) {
  return (
    <section className="aq-section aq-achievements" id="achievements">
      <div className="aq-container">
        <div className="aq-section-head">
          <h2 className="aq-headline">
            {lang === "ar" ? "إنجازات أمان-كو" : "Aman-QO Achievements"}
          </h2>
          <p className="aq-muted">
            {lang === "ar"
              ? "محطات مهمة وجوائز ومشاركات تثبت أثرنا في الأمن السيبراني."
              : "Key milestones, awards, and appearances that reflect our impact."}
          </p>
        </div>

        <div className="aq-grid-3">
          <div className="aq-card aq-card-glow">
            <h3>
              {lang === "ar"
                ? "جائزة هاكاثون الأمن السيبراني"
                : "Cybersecurity Hackathon Award"}
            </h3>
            <p className="aq-muted">
              {lang === "ar"
                ? "جائزة رائد الأمن السيبراني الشبابي بقيمة 100,000 جنيه."
                : "Young Cybersecurity Entrepreneur Award (EGP 100,000)."}
            </p>
          </div>

          <div className="aq-card aq-card-glow">
            <h3>{lang === "ar" ? "تغطية إعلامية" : "Media Coverage"}</h3>
            <p className="aq-muted">
              {lang === "ar"
                ? "تغطيات صحفية لنجاحنا ومشاركاتنا في فعاليات الأمن الرقمي."
                : "Press mentions highlighting our success and participation."}
            </p>
          </div>

          <div className="aq-card aq-card-glow">
            <h3>{lang === "ar" ? "مشاركات وفعاليات" : "Events & Speaking"}</h3>
            <p className="aq-muted">
              {lang === "ar"
                ? "حضور فعّال في معارض ومؤتمرات لتعزيز الوعي والحماية."
                : "Active presence in expos and conferences to drive awareness."}
            </p>
          </div>
        </div>

        <div className="aq-gallery-4">
          <img
            className="aq-img aq-img-big"
            src={ach1}
            alt={lang === "ar" ? "إنجاز 1" : "Achievement 1"}
            loading="lazy"
          />
          <img
            className="aq-img aq-img-big"
            src={ach2}
            alt={lang === "ar" ? "إنجاز 2" : "Achievement 2"}
            loading="lazy"
          />
          <img
            className="aq-img aq-img-big"
            src={ach3}
            alt={lang === "ar" ? "إنجاز 3" : "Achievement 3"}
            loading="lazy"
          />
          <img
            className="aq-img aq-img-big"
            src={ach4}
            alt={lang === "ar" ? "إنجاز 4" : "Achievement 4"}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
